import React from 'react'
import styled from 'styled-components'
import { values } from '../../lib/ramda'
import { Badge } from '../../components/Badge'

const StyledSchoolFeeBadge = styled(Badge)`
  padding: 0;
`

const getDisplayFeeContent = (feeArray) => {
  const initialValue = feeArray[0]
  const dollarSymbol = '$'
  let content = ''
  const { max, min } = feeArray.reduce(
    (a, c) => ({
      min: Math.min(a.min, c),
      max: Math.max(a.max, c),
    }),
    { max: initialValue, min: initialValue }
  )

  if (min === 0 && max === 0) {
    return null
  }
  if (min === max) {
    return `${dollarSymbol}${max}`
  }

  if (min !== 0) {
    content = `${dollarSymbol}${min}`
  }

  if (max !== 0) {
    if (content) {
      return `${content} - ${dollarSymbol}${max}`
    }
    return `${dollarSymbol}${max}`
  }
  return null
}

interface ISchoolFeeBadgeProps {
  title?: string
  fee?: object
}

const SchoolFeeBadge: React.FC<ISchoolFeeBadgeProps> = ({ title, fee }) => {
  if (!fee || Object.keys(fee).length === 0) {
    return null
  }

  const content = getDisplayFeeContent(values(fee))
  if (!content) {
    return null
  }
  return <StyledSchoolFeeBadge title={title}>{content}</StyledSchoolFeeBadge>
}

export { SchoolFeeBadge }
